import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6e1ddfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmCommunitySetting",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body w-100 mx-2" }
const _hoisted_8 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_9 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_10 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_11 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_12 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-8"
}
const _hoisted_14 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_15 = { class: "img-container" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "row mx-0 px-0 py-2 col-lg-8"
}
const _hoisted_18 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-max-content col-lg-4 col-form-label fw-bold" }, null, -1))
const _hoisted_20 = { class: "col-lg-8" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_23 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { buildFormData } from '@/utils'
import communityServices from '@/services/communities.service'
import { COMMUNITY_STORE } from '@/store/constants'
import { addCommunitySiteHeaderParams } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({
      community_site_header_text: '',
    }),
  },
  showMessageError: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()

const modalSuccess = ref()



const onSubmit = async (): Promise<void> => {
  const { data } = props
  props.showMessageError(false)

  const formData = new FormData()
  await buildFormData(formData, {
    community_site_header_text: data.community_site_header_text,
  })
  if (data.headerImage?.file && data.headerImage?.file !== data.community_site_image_url) {
    if (typeof data.headerImage.imgData === 'string') {
      formData.append('community_site_image_url', data.headerImage?.imgData)
    } else {
      formData.append('community_site_image', data.headerImage?.imgData)
    }
  } else {
    if (data.community_site_image_url && data.headerImage?.file !== data.community_site_image_url) {
      formData.append('remove_community_site_image', true)
    }
  }

  try {
    const response = await communityServices.updateCommunityApi({ id: route.params?.id, formData: formData })

    if (response.status === 200) {
      store.dispatch(COMMUNITY_STORE.ACTIONS.UPDATE_COMMUNITY_INFO, {
        community_site_header_text: data.community_site_header_text,
        community_site_image_url: data.community_site_image_url,
      })
      modalSuccess.value?.show()

      props.showMessageError(false)
      return
    }

    props.showMessageError(true)
  } catch (error) {
    console.log(error)
    props.showMessageError(true)
  }
}

onMounted(() => {
  modalSuccess.value = new Modal(document.getElementById('modalUpdateCommunitySettingSuccess'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CL11title')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('communitySiteManagementHeaderText')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.data.community_site_header_text), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", {
                class: _normalizeClass(['w-max-content col-lg-4 col-form-label fw-bold', __props.data.headerImage?.file ? 'mt-4' : ''])
              }, _toDisplayString(_unref(translate)('headerLogo')), 3),
              (__props.data.headerImage?.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: _unref(addCommunitySiteHeaderParams)(__props.data.headerImage?.imgPreview),
                          alt: "img"
                        }, null, 8, _hoisted_16)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!__props.data.headerImage?.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " （未設定） "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)('CL10TextConfirm')), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(Button, {
                  title: _unref(translate)('CL10UpdateBtnText'),
                  type: 'secondary',
                  onClick: onSubmit,
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})